import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';

import { StyledReserveWarningAlert, StyledAlertTitle } from '@this/components/shared/reserve_ui_components';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Section } from '@this/components/reserve_trip/reserve_confirm/routings/input_customer_information/trip_rule_section/trip_rule_error_section';
import type Hotel from '@this/src/domain/hotel/hotel';
import type { RestrictedHotelPlanLogAPIProps } from '@this/src/api/trips/restricted_hotel_plan_log_api';
import restrictedHotelPlanLogAPI from '@this/src/api/trips/restricted_hotel_plan_log_api';

interface Props {
  restrictedHotels: Hotel[];
  apiProps?: RestrictedHotelPlanLogAPIProps;
}

const SESSION = 'restrictedHotelPlanLogsLastSent';

const handleRestrictedHotelPlanLogs = (apiProps?: RestrictedHotelPlanLogAPIProps) => {
  if (!apiProps?.sendLog) {
    return;
  }

  const cacheKey = JSON.stringify(_.pick(apiProps, ['searchQueryId']));
  const lastSent = sessionStorage.getItem(SESSION);

  if (lastSent === cacheKey) {
    return;
  }

  sessionStorage.setItem(SESSION, cacheKey);

  restrictedHotelPlanLogAPI({
    ...apiProps,
    restrictedHotels: apiProps.restrictedHotels || [],
    onError: () => {
      sessionStorage.removeItem(SESSION);
    }
  });
};

const RestrictedHotelSection = observer(({ restrictedHotels, apiProps }: Props) => {
  useEffect(() => handleRestrictedHotelPlanLogs(apiProps), [apiProps, apiProps?.sendLog]);

  return (
    <StyledReserveWarningAlert icon={<ErrorOutlineIcon />} variant="filled" severity="error">
      <StyledAlertTitle>条件つき宿泊プランの可能性がございます</StyledAlertTitle>
      <Section>
        <p>・対象の施設：{restrictedHotels[0].name}</p>
        <p>・宿泊プラン名：{restrictedHotels.map(hotel => hotel.plan_name).join('、')}</p>
        <p>
          条件を満たしていない場合、宿泊ができない・追加の支払いが求められる可能性があります。
          <br />
          プランをよくご確認の上、ご依頼ください。
          <br />
          事前申請機能をご利用の場合、依頼時のプランが売り切れで、承認時のプランとに差異が発生する場合があります。
          <br />
          ※上記の場合、条件が付帯しないプランが選択されます。
        </p>
      </Section>
    </StyledReserveWarningAlert>
  );
});

export default RestrictedHotelSection;
